export default __webpack_public_path__ + "static/media/copy.ccf25429.svg";